import { IDocument } from 'interfaces';
import React from 'react';
import classes from './FileStatuses.module.scss'
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

type FileStatusesProps = {
  file: IDocument;
  onSectionIconClick?: (section: string, info: any) => void;
  simpleMode?: boolean;
  viewMode?: boolean;
  version?: IDocument | null;
};

const FileStatuses = ({file, onSectionIconClick, simpleMode, viewMode, version}: FileStatusesProps) => {
  const personalAgreement = file.user_agreement_status === 'awaiting_acceptance';
  const personalSinging = file.user_signing_status === 'awaiting_acceptance'

  const { t } = useTranslation();
  
  return (
    <div
      className={cn(
        classes.statusesWrap,
        simpleMode ? classes.simpleMode : 'null',
        viewMode ? classes.viewMode : 'null'
      )}
    >
      {!version && file.is_new && (
        <div className={cn(classes.statusItem, classes.new)}>{t('Documents.table.status.new')}</div>
      )}
      {!version && file.signing_status === 0 && (
        <div
          onClick={() => onSectionIconClick && onSectionIconClick('file_setting.signing', file)}
          className={cn(classes.statusItem, personalSinging ? classes.personal : classes.progress)}
        >
          {personalSinging
            ? t('Documents.table.status.awaiting_my_signing')
            : t('Documents.table.status.awaiting_signing')
          }
        </div>
      )}
      {!version && file.signing_status === 1 && (
        <div
          onClick={() => onSectionIconClick && onSectionIconClick('file_setting.signing', file)}
          className={cn(classes.statusItem, classes.rejected)}
        >
          {t('Documents.table.status.rejected_signing')}
        </div>
      )}
      {!version && file.signing_status === 2 && (
        <div
          onClick={() => onSectionIconClick && onSectionIconClick('file_setting.signing', file)}
          className={cn(classes.statusItem, classes.new)}
        >
          {t('Documents.table.status.signed')}
        </div>
      )}
      {!version && file.agreement_status === 0 && (
        <div
          onClick={() => onSectionIconClick && onSectionIconClick('file_setting.agreement', file)}
          className={cn(classes.statusItem, personalAgreement ? classes.personal : classes.progress)}
        >
          {personalAgreement
            ? t('Documents.table.status.awaiting_my_approval')
            : t('Documents.table.status.awaiting_approval')
          }
        </div>
      )}
      {!version && file.agreement_status === 1 && (
        <div
          onClick={() => onSectionIconClick && onSectionIconClick('file_setting.agreement', file)}
          className={cn(classes.statusItem, classes.rejected)}
        >
          {t('Documents.table.status.rejected_approval')}
        </div>
      )}
      {!version && file.agreement_status === 2 && (
        <div
          onClick={() => onSectionIconClick && onSectionIconClick('file_setting.agreement', file)}
          className={cn(classes.statusItem, classes.new)}
        >
          {t('Documents.table.status.approved')}
        </div>
      )}
      {version && (
        <div
          className={cn(classes.oldVersion)}
        >
          {t('Documents.table.status.outDated')}
        </div>
      )}
    </div>
  );
}

export default FileStatuses;
